import { ReactNode } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import koraIcon from '@/assets/imgs/kora-icon.svg';

interface AuthCardLayoutProps {
  titulo: string;
  descricao: string;
  children: ReactNode;
}

export function AuthCardLayout({ titulo, descricao, children }: AuthCardLayoutProps) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#161616] p-4">
      <div
        className="pointer-events-none absolute -top-1/4 left-1/2 h-[50rem] w-[50rem] -translate-x-1/2 rounded-full opacity-40 blur-3xl"
        style={{ background: 'radial-gradient(circle, hsl(var(--primary) / 0.5), transparent 70%)' }}
      />
      <Card className="relative z-10 w-full max-w-md border-border/60 bg-card/95 shadow-2xl backdrop-blur-md">
        <CardHeader className="space-y-3 pb-2 text-center">
          <div className="mx-auto rounded-2xl bg-card p-3 shadow-md ring-1 ring-border">
            <img src={koraIcon} alt="kora" className="h-16 w-16 object-contain" />
          </div>
          <CardTitle className="font-display text-xl">{titulo}</CardTitle>
          <CardDescription>{descricao}</CardDescription>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  );
}
